// eslint-disable-next-line jira/filename-case
import React from 'react';
import { styled } from '@compiled/react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import AkSpinner from '@atlaskit/spinner/spinner';

export default function Spinner({ testId }: { testId?: string }): React.JSX.Element {
	return (
		<UFOLoadHold name="legacy-spinner">
			<Container>
				<Wrapper>
					<AkSpinner size="large" testId={testId} />
				</Wrapper>
			</Container>
		</UFOLoadHold>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignContent: 'center',
	height: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	alignSelf: 'center',
});
